module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/rc-switch/es/index.js
// module id = 403
// module chunks = 0